import { z } from 'zod/v4';
import { SearchFilterQuerySchema, } from '../schemas/SearchRequest.js';
z.globalRegistry.add(SearchFilterQuerySchema, { id: 'SearchFilter' });
//# sourceMappingURL=search.js.map